import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

/**
 * Tray-and-arrow "upload" glyph: the mirror of `DownloadIcon`, drawn with `currentColor` so it
 * takes the `color` of its container like a Material icon does.
 */
const UploadIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 20 20'} fill="none" {...props}>
    <path
      fill="none"
      d="M10 2.5V12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="none"
      d="M5.83337 6.66669L10 2.5L14.1667 6.66669"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
export default UploadIcon
